export default __webpack_public_path__ + "static/collectly-d8801a04a7fc3396e64a01e445f83813.png";